module.exports = __webpack_public_path__ + "static/img/btn-create-poster.6558f85a.png";